module.exports = __webpack_public_path__ + "static/media/Locksymbol.cc169be2.svg";